<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12">
        <v-row class='title'>
          <v-col cols='12'>
            <h2>Broadcast</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='5'>
            <p class="sub-head">เป้าหมายโดยประมาณ</p>
            <p style="font-size: 12px; color: #2e263d" class="set-margin0">
              ตัวเลขที่แสดงเป็นค่าโดยประมาณจึงอาจแตกต่างจากจำนวนที่บรอดแคสต์จริง
            </p>
            <div class="cycle">
              <v-progress-circular :rotate="180" :size="180" :width="25" value="50" color="#16B1FF">
                50%
              </v-progress-circular>
            </div>
            <div>
              <p class="sub-head">Filter</p>
              <v-row align="center" class="no-padding-bottom pt-3">
                <!-- Text Field: คะแนนต่ำสุด -->
                <v-col cols="3">
                  <v-text-field v-model="minScore" label="คะแนนต่ำสุด" type="number" outlined dense hide-details
                    color='#16B1FF' class="custom-range-slider"></v-text-field>
                </v-col>

                <!-- Range Slider -->
                <v-col cols="6">
                  <v-range-slider hide-details v-model="scoreRange" :min="minScore" :max="maxScore"
                    step="1"></v-range-slider>
                </v-col>

                <!-- Text Field: คะแนนสูงสุด -->
                <v-col cols="3">
                  <v-text-field v-model="maxScore" label="คะแนนสูงสุด" type="number" outlined dense
                    hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center" class="no-padding-bottom pt-3">
                <!-- Text Field: คะแนนต่ำสุด -->
                <v-col cols="3">
                  <v-text-field v-model="minScore" label="อายุต่ำสุด" type="number" outlined dense
                    hide-details></v-text-field>
                </v-col>

                <!-- Range Slider -->
                <v-col cols="6">
                  <v-range-slider hide-details v-model="scoreRange" :min="minScore" :max="maxScore"
                    step="1"></v-range-slider>
                </v-col>

                <!-- Text Field: คะแนนสูงสุด -->
                <v-col cols="3">
                  <v-text-field v-model="maxScore" label="อายุสูงสุด" type="number" outlined dense
                    hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="ระดับ" label="ระดับ" :items="['California']" outlined dense
                    hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="เพศ" label="เพศ" :items="['California']" outlined dense
                    hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="บริการที่ใช้ล่าสุด" label="บริการที่ใช้ล่าสุด" :items="['California']" outlined
                    dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
                <v-col cols="6" class="setPadding">
                  <v-select placeholder="?" label="?" :items="['California']" outlined dense hide-details></v-select>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <div class="line col-1">
            <v-divider vertical></v-divider>
          </div>
          <v-col cols='6' class='pl-0'>
              <div class='d-flex justify-center align-center flex-wrap'>
                <p class="sub-head pr-5">รายชื่อลูกค้า</p>
                <v-text-field label="" placeholder="Search" outlined dense hide-details class='pr-2' append-icon="mdi-map-marker"></v-text-field>
                <div class='pr-2'>
                  <v-btn color='#386CB9' dark>import <v-icon>mdi-arrow-collapse-down</v-icon></v-btn>
                </div>

                <v-btn color='#259D5B' dark>template <v-icon>mdi-file-excel</v-icon></v-btn>
              </div>
              <div style="padding-top: 15px;">
                <v-data-table
    v-model="selectedItems"
    :headers="headers"
    :items="desserts"
    item-key="nameCustomer"
    :items-per-page="5"
    class="elevation-1"
    show-select>
  </v-data-table>
              </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div style="
        border-style: solid;
        border-radius: 6px;
        border-color: #2e263d29;
      ">
                 <div style="
  display: flex;
  padding: 10px 15px;
  gap: 8px; /* เพิ่มระยะห่างระหว่างปุ่มทั้งหมดเป็น 8px */
">
  <v-btn tonal color="#2e263d14" width='150'>
    <v-icon>mdi-message-processing</v-icon>ข้อความ
  </v-btn>
  <v-btn variant="tonal" color="#2e263d14" width='150'>
    <v-icon>mdi-image</v-icon>รูปภาพ
  </v-btn>
  <v-btn variant="tonal" width='150' color="#2e263d14">
    <v-icon>mdi-gift</v-icon>ของรางวัล
  </v-btn>
  <v-btn variant="tonal" width='150' color="#2e263d14">
    <v-icon>mdi-star</v-icon>กิจกรรม
  </v-btn>
  <v-btn variant="tonal" width='150' color="#2e263d14">
    <v-icon>mdi-video</v-icon>วิดีโอ
  </v-btn>
</div>
                <div style="padding: 10px 15px;">
                  <v-textarea label="Three rows" row-height="35" rows="5" counter='5' outlined auto-grow></v-textarea>
                </div>
            </div>
          </v-col>
        </v-row>

      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
export default {
  name: 'LoyaltyProdBroadCast',

  data () {
    return {
      session: this.$session.getAll(),
      minScore: 0,
      maxScore: 100,
      scoreRange: [20, 80],
      selectedItems: [], // เก็บรายการที่ถูกเลือก
      headers: [
        { text: 'ชื่อ', value: 'nameCustomer' },
        { text: 'ระดับสมาชิก', value: 'LevelName' },
        { text: 'เพศ', value: 'gender' },
        { text: 'อายุ', value: 'age' },
        { text: 'บริการล่าสุด', value: 'ProductExchangeRateName' },
        { text: 'รับข่าวสาร', value: 'CONDITION_TERM2' }
      ],
      desserts: [
        {nameCustomer: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1,
          selectable: true}
      ], // ข้อมูลสมาชิกที่จะแสดงในตาราง
      data: [],
      dataProductExchangRate: []
    }
  },

  async mounted () {
    // await this.getMember()
    await this.getProductExchangRate()
  },

  methods: {
    async getMember () {
      try {
        const res = await axios.get(`${this.DNS_IP}/member/get?shopId=${this.$session.getAll().data.shopId}`)
        let rs = res.data

        if (rs.status === false) {
          this.desserts = []
        } else {
          this.desserts = rs.map(el => {
            if (el.gender === 'male') {
              el.gender = 'ชาย'
            } else if (el.gender === 'female') {
              el.gender = 'หญิง'
            } else if (el.gender === 'ไม่ระบุ' || el.gender === 'lgbt') {
              el.gender = 'ไม่ระบุ'
            }

            if (el.CONDITION_TERM2 === 'True') {
              el.CONDITION_TERM2 = 'รับข่าวสาร'
              el.selectable = false // กำหนดแถวให้สามารถเลือกได้
            } else {
              el.CONDITION_TERM2 = 'ไม่รับข่าวสาร'
              el.selectable = true // กำหนดแถวให้ไม่สามารถเลือกได้
            }

            return el // อย่าลืมคืนค่า el เพื่อให้ map ทำงานได้อย่างถูกต้อง
          })
        }
      } catch (error) {
        console.error('Error fetching members:', error)
      }
    },
    async getProductExchangRate () {
      await axios.get(this.DNS_IP + '/productExchangeRate/get?shopId=' + this.$session.getAll().data.shopId).then(res => {
        let rs = res.data
        if (rs === false) {
          this.dataProductExchangRate = []
        } else {
          rs.map(el => {
            el.text = el.name
            el.value = el.productExchangeRateId
            this.dataProductExchangRate.push(el)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.title {

  height: 60px;
  width: 100%;
  padding-top: 20px;
}

.content {

  height: 1190px;
  width: 100%;
}

.content-top {

  height: 840px;
  display: flex;
  justify-content: space-between;
}

.content-condition {

  width: 430px;
  height: 860px;
}

.progress-cycle {
  height: 307px;

  width: 100%;
  /* margin-bottom: 20px; */
}

.conditions {
  height: calc(100% - 307px);

  width: 100%;
}

.line {
  display: flex;
  justify-content: center;
  align-items: center;
  /* สีพื้นหลังของเส้นแบ่ง */
  width: 5px;
  height: 800px;
  padding: 12px 0;
}

.content-data-member {

  width: calc(100% - 460px - 10px);
  /* หักลบความกว้างของ content-condition และ line */
  height: 860px;
}

.content-bottom {

  height: 300px;
  width: 100%;
}

.sub-head {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.cycle {
  display: flex;
  justify-content: center;
  align-content: center;
}

.point {
  display: flex;
}

.setPadding {
  padding: 12px 15px 0;
}

.v-simple-checkbox .v-icon {
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BroadCast/BroadCast.vue